import React from 'react'
import LogoWithText from '../../../components/LogoWithText'

const PublicAppBar: React.FC = () => {
	return (
		<div className='app-bar bg-background-100-light dark:bg-background-100-dark text-text-dark dark:text-white h-[5.7rem] border-b border-[#c3c3c3] dark:border-[#0d2d30]'>
			<div className='flex w-full items-center justify-center'>
				<LogoWithText size={64} />
			</div>
		</div>
	)
}

export default PublicAppBar
